import type { Event } from "react-big-calendar";

export interface CalendarEvent extends Event {
  calendarId: string;
  id: string;
  iCalUId?: string;
  organizer?: string;
  description?: string;
  location?: string;
  attendees?: string[];
  showAs?: "Free" | "Tentative" | "Busy" | "WorkingElsewhere" | "Oof";
  categories: string[];
  priority: "low" | "medium" | "high";
  eventType?: "SingleInstance" | "SeriesMaster" | "Occurrence" | "Exception" | "BackgroundEvent";
  recurring?: Recurring;
  createDate?: Date;
  sensitivity?: "Normal" | "Personal" | "Private" | "Confidential";
  readAccessLevel?: string;
  startOffset?: Date;
  endOffset?: Date;
}
export interface CustomWeekViewEvent extends CalendarEvent {
  isStartOfDay?: boolean;
  isEndOfDay?: boolean;
}
export class Recurring {
  seriesMasterId?: string;
  recurringType?: "daily" | "weekly" | "monthly" | "yearly";
  recurringEndDate?: Date;
  constructor(data: Partial<Recurring>) {
    Object.assign(this, data);
  }
}
